(function () {
  'use strict';

  function formatMoney(cents) {
    if (!cents) return '';
    var amount = (cents / 100).toLocaleString('cs-CZ', { maximumFractionDigits: 0 });
    return amount + ' Kč';
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function low(value) {
    return String(value || '').toLowerCase();
  }

  function numsFrom(list) {
    var seen = {};
    var nums = [];
    (list || []).forEach(function (value) {
      var n = parseInt(String(value).replace(/\s/g, ''), 10);
      if (!n || seen[n]) return;
      seen[n] = true;
      nums.push(n);
    });
    nums.sort(function (a, b) {
      return a - b;
    });
    return nums;
  }

  function formatPeriods(list) {
    var nums = numsFrom(list);
    if (!nums.length) return '';
    var unit = 'měsíců';
    if (nums.length === 1) return nums[0] + ' ' + unit;
    if (nums.length === 2) return nums[0] + ' nebo ' + nums[1] + ' ' + unit;
    return nums.slice(0, -1).join(', ') + ' nebo ' + nums[nums.length - 1] + ' ' + unit;
  }

  function formatMileages(list) {
    var nums = numsFrom(list);
    if (!nums.length) return '';
    var min = nums[0].toLocaleString('cs-CZ');
    var max = nums[nums.length - 1].toLocaleString('cs-CZ');
    if (nums.length === 1 || min === max) return min + ' km';
    return min + ' až ' + max + ' km';
  }

  function wheelLabel(lines) {
    var line = (lines || []).filter(function (item) {
      return low(item).indexOf('kola') !== -1;
    })[0];
    if (!line) return '';
    var size = (String(line).match(/(\d+)\s*"/) || [])[1];
    var text = low(line);
    if (!size) return line;
    if (text.indexOf('ocel') !== -1) return size + '" ocelová kola';
    if (text.indexOf('slitin') !== -1 || text.indexOf('alu') !== -1 || text.indexOf('hlin') !== -1) {
      return size + '" kola z lehké slitiny';
    }
    return size + '" kola';
  }

  function climateLabel(lines) {
    var line = (lines || []).filter(function (item) {
      return /climatronic|klimatiz/i.test(item);
    })[0];
    if (!line) return '';
    var match = String(line).match(/((?:jedno|dvou|tří|čtyř)zón\S*)\s+(climatronic|klimatizace)/i);
    if (!match) return String(line).trim();
    var zone = match[1].charAt(0).toUpperCase() + match[1].slice(1);
    var kind = /climatronic/i.test(match[2]) ? 'Climatronic' : 'klimatizace';
    return zone + ' ' + kind;
  }

  function parkLabel(lines) {
    var line = (lines || []).filter(function (item) {
      return /parkovac|kamera/i.test(item);
    })[0];
    if (!line) return '';
    var text = low(line);
    var front = text.indexOf('přední') !== -1;
    var rear = text.indexOf('zadní') !== -1;
    var cam = text.indexOf('kamera') !== -1;
    if (front && rear && cam) return 'Parkovací senzory a zadní kamera';
    if (front && rear) return 'Přední a zadní parkovací senzory';
    if (rear) return 'Zadní parkovací senzory';
    if (front) return 'Přední parkovací senzory';
    if (cam) return 'Parkovací kamera';
    return String(line).trim();
  }

  function comfortLabel(lines) {
    var list = lines || [];
    if (!list.length) return '';
    var seats = list.some(function (item) {
      return /vyhřív/i.test(item) && /sedad/i.test(item);
    });
    var wheel = list.some(function (item) {
      return /vyhřív/i.test(item) && /volant/i.test(item);
    });
    if (seats && wheel) return 'Vyhřívaná sedadla a volant';
    if (seats) return 'Vyhřívaná sedadla';
    if (wheel) return 'Vyhřívaný volant';
    return 'Bez vyhřívání';
  }

  function categorized(line) {
    var text = low(line);
    if (text.indexOf('kola') !== -1) return true;
    if (/climatronic|klimatiz/.test(text)) return true;
    if (/parkovac|kamera/.test(text)) return true;
    if (/vyhřív/.test(text) && /sedad|volant/.test(text)) return true;
    return false;
  }

  function extraScore(line) {
    var text = low(line);
    if (
      /reproduktor|bluetooth|usb|dab|isofix|dešť|světelný senzor|tónovan|smartlink|startování tlačítkem|nouzový|omezovač|tempomat|provozní napětí|displej|carplay|android|asistent|jízdním pruhu|mrtvého|dopravních značek|zrcát|skla|sedadla vpředu|výškově/.test(
        text,
      )
    ) {
      return 0;
    }
    if (/nabíjen|nabijen|tažn|bezklíč|bezklic|střech|strech|bezdrát|bezdrat|v2l|v2h|panoram|ventilac/.test(text))
      return 2;
    return 1;
  }

  function extraLabel(trim, all) {
    var own = (trim.lines || []).filter(function (line) {
      return !categorized(line);
    });
    var cheaper = [];
    all.forEach(function (other) {
      if (other.price >= trim.price) return;
      (other.lines || []).forEach(function (line) {
        if (cheaper.indexOf(low(line)) === -1) cheaper.push(low(line));
      });
    });
    var unique = own.filter(function (line) {
      return cheaper.indexOf(low(line)) === -1;
    });
    var pick = unique.filter(function (line) {
      return extraScore(line) > 0;
    });
    if (!pick.length) {
      pick = own.filter(function (line) {
        return /rychlé nabíjení|rychle nabijen|\bdc\b/i.test(line);
      });
    }
    var strong = pick.filter(function (line) {
      return extraScore(line) >= 2;
    });
    if (strong.length) pick = strong;
    pick.sort(function (a, b) {
      return extraScore(b) - extraScore(a);
    });
    return pick
      .slice(0, 3)
      .map(function (line) {
        return String(line).replace(/\s+/g, ' ').trim();
      })
      .join(', ');
  }

  function plainNum(value) {
    var match = String(value || '').match(/[\d]+([.,]\d+)?/);
    return match ? match[0].replace('.', ',') : '';
  }

  function sharedLead(list) {
    var powers = [];
    var bats = [];
    var gears = [];
    var electric = false;
    list.forEach(function (item) {
      var power = plainNum(item.power);
      var bat = plainNum(item.battery);
      if (power && powers.indexOf(power) === -1) powers.push(power);
      if (bat && bats.indexOf(bat) === -1) bats.push(bat);
      if (item.gear && gears.indexOf(item.gear) === -1) gears.push(item.gear);
      if (/elekt/i.test(item.fuel || '') || bat) electric = true;
    });
    if (powers.length !== 1) return '';
    var gear = '';
    if (gears.length === 1) {
      gear = /utomat/i.test(gears[0]) ? 'automatickou převodovku' : 'manuální převodovku';
    }
    if (electric && bats.length === 1) {
      return (
        'Všechny verze mají elektromotor ' +
        powers[0] +
        ' kW, baterii ' +
        bats[0] +
        ' kWh' +
        (gear ? ' a ' + gear : '') +
        '.'
      );
    }
    if (gear) return 'Všechny verze mají motor ' + powers[0] + ' kW a ' + gear + '.';
    return '';
  }

  function formatCell(value) {
    if (value == null || value === '') return '—';
    return esc(
      String(value).replace(/\b(\d{4,})\b/g, function (num) {
        return Number(num).toLocaleString('cs-CZ');
      }),
    );
  }

  function buildTable(root) {
    if (!root) return;
    var payloadEl = root.querySelector('[data-trim-compare-payload]');
    var tableWrap = root.querySelector('[data-trim-compare-root]');
    var head = root.querySelector('[data-trim-compare-head]');
    var body = root.querySelector('[data-trim-compare-body]');
    var foot = root.querySelector('[data-trim-compare-foot]');
    if (!payloadEl || !tableWrap || !head || !body || !foot) return;

    var items = [];
    try {
      items = JSON.parse(payloadEl.textContent || '[]');
    } catch (e) {
      items = [];
    }

    var byTrim = {};
    items.forEach(function (item) {
      var key = item.trim;
      if (!key) return;
      if (!byTrim[key]) {
        byTrim[key] = Object.assign({}, item, {
          periods: (item.periods || []).slice(),
          mileages: (item.mileages || []).slice(),
          lines: (item.lines || []).slice(),
        });
        return;
      }
      var dest = byTrim[key];
      if (item.price < dest.price) {
        dest.price = item.price;
        dest.url = item.url;
        dest.image = item.image;
        dest.title = item.title;
        dest.handle = item.handle;
        if (item.range) dest.range = item.range;
        if (item.power) dest.power = item.power;
        if (item.battery) dest.battery = item.battery;
        if (item.gear) dest.gear = item.gear;
        if (item.fuel) dest.fuel = item.fuel;
      }
      (item.periods || []).forEach(function (value) {
        if (value && dest.periods.indexOf(value) === -1) dest.periods.push(value);
      });
      (item.mileages || []).forEach(function (value) {
        if (value && dest.mileages.indexOf(value) === -1) dest.mileages.push(value);
      });
      (item.lines || []).forEach(function (value) {
        if (value && dest.lines.indexOf(value) === -1) dest.lines.push(value);
      });
    });

    var trims = Object.keys(byTrim)
      .map(function (k) {
        return byTrim[k];
      })
      .sort(function (a, b) {
        return a.price - b.price;
      });

    var maxCols = Number(root.getAttribute('data-max-columns') || 4);
    trims = trims.slice(0, maxCols);

    var sectionInner = root.querySelector('.collection-trim-compare');

    if (trims.length < 2) {
      tableWrap.hidden = true;
      if (sectionInner) sectionInner.hidden = true;
      return;
    }

    if (sectionInner) sectionInner.hidden = false;

    var ctaLabel = root.getAttribute('data-cta-label') || 'Zobrazit nabídku';
    var colTrim = root.getAttribute('data-col-trim') || 'Výbava';
    var rowPeriod = root.getAttribute('data-row-period') || 'Délka pronájmu';
    var rowMileage = root.getAttribute('data-row-mileage') || 'Roční nájezd';
    var pricePrefix = root.getAttribute('data-price-prefix') || 'od';

    var arrow =
      '<svg class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none" aria-hidden="true" focusable="false"><path d="M13.0306 6.53063L8.53063 11.0306C8.38973 11.1715 8.19863 11.2507 7.99938 11.2507C7.80012 11.2507 7.60902 11.1715 7.46813 11.0306C7.32723 10.8897 7.24807 10.6986 7.24807 10.4994C7.24807 10.3001 7.32723 10.109 7.46813 9.96813L10.6875 6.75H1.5C1.30109 6.75 1.11032 6.67098 0.96967 6.53033C0.829018 6.38968 0.75 6.19891 0.75 6C0.75 5.80109 0.829018 5.61032 0.96967 5.46967C1.11032 5.32902 1.30109 5.25 1.5 5.25H10.6875L7.46937 2.03C7.32848 1.8891 7.24932 1.69801 7.24932 1.49875C7.24932 1.29949 7.32848 1.1084 7.46937 0.967501C7.61027 0.826604 7.80137 0.74745 8.00062 0.74745C8.19988 0.74745 8.39098 0.826604 8.53187 0.967501L13.0319 5.4675C13.1018 5.53727 13.1573 5.62017 13.1951 5.71144C13.2329 5.8027 13.2523 5.90054 13.2522 5.99932C13.252 6.09811 13.2324 6.1959 13.1944 6.28707C13.1564 6.37825 13.1007 6.46102 13.0306 6.53063Z" fill="currentColor"/></svg>';

    var headRow = '<tr><th scope="col">' + esc(colTrim) + '</th>';
    trims.forEach(function (t) {
      headRow += '<th scope="col"><div class="collection-trim-compare__trim-head">';
      if (t.image) {
        headRow += '<img src="' + esc(t.image) + '" alt="' + esc(t.trim) + '" loading="lazy" width="180">';
      }
      headRow +=
        '<strong>' +
        esc(t.trim) +
        '</strong><span>' +
        esc(pricePrefix) +
        ' ' +
        formatMoney(t.price) +
        '</span></div></th>';
    });
    headRow += '</tr>';
    head.innerHTML = headRow;

    trims.forEach(function (trim) {
      if (!trim.periods || !trim.periods.length) trim.periods = trim.period ? [trim.period] : [];
      if (!trim.mileages || !trim.mileages.length) trim.mileages = trim.mileage ? [trim.mileage] : [];
      trim.periodLabel = formatPeriods(trim.periods);
      trim.mileageLabel = formatMileages(trim.mileages);
      var rangeNum = plainNum(trim.range);
      trim.rangeLabel = rangeNum ? 'až ' + rangeNum + ' km' : '';
      trim.wheelLabel = wheelLabel(trim.lines);
      trim.climateLabel = climateLabel(trim.lines);
      trim.parkLabel = parkLabel(trim.lines);
      trim.comfortLabel = comfortLabel(trim.lines);
    });
    trims.forEach(function (trim) {
      trim.extraLabel = extraLabel(trim, trims);
    });

    var leadEl = root.querySelector('.collection-trim-compare__lead');
    var sentence = sharedLead(trims);
    if (leadEl && sentence && !leadEl.querySelector('[data-trim-shared]')) {
      var shared = document.createElement('p');
      shared.setAttribute('data-trim-shared', '1');
      shared.textContent = sentence;
      leadEl.insertBefore(shared, leadEl.firstChild);
    }

    var rows = [
      { label: rowPeriod, key: 'periodLabel' },
      { label: rowMileage, key: 'mileageLabel' },
      { label: 'Dojezd podle výrobce', key: 'rangeLabel' },
      { label: 'Kola', key: 'wheelLabel' },
      { label: 'Klimatizace', key: 'climateLabel' },
      { label: 'Parkování', key: 'parkLabel' },
      { label: 'Komfort', key: 'comfortLabel' },
      { label: 'Navíc', key: 'extraLabel' },
    ].filter(function (row) {
      return trims.some(function (trim) {
        return trim[row.key];
      });
    });

    body.innerHTML = rows
      .map(function (row) {
        var cells =
          '<tr><th scope="row">' +
          row.label +
          '</th>' +
          trims
            .map(function (t) {
              return '<td>' + formatCell(t[row.key]) + '</td>';
            })
            .join('') +
          '</tr>';
        return cells;
      })
      .join('');

    foot.innerHTML =
      '<tr><th scope="row"></th>' +
      trims
        .map(function (t) {
          return (
            '<td><a class="collection-trim-compare__link" href="' +
            esc(t.url) +
            '">' +
            esc(ctaLabel) +
            ' ' +
            arrow +
            '</a></td>'
          );
        })
        .join('') +
      '</tr>';

    tableWrap.hidden = false;
    bindTrimNav(tableWrap);
  }

  function columnWidth(wrap) {
    var col = wrap.querySelector('thead th:nth-child(2)');
    return col ? col.getBoundingClientRect().width : 0;
  }

  function updateTrimNav(wrap) {
    var scroller = wrap.closest('.collection-trim-compare__scroller');
    if (!scroller) return;
    var prev = scroller.querySelector('[data-trim-compare-prev]');
    var next = scroller.querySelector('[data-trim-compare-next]');
    var max = wrap.scrollWidth - wrap.clientWidth;
    var x = wrap.scrollLeft;
    if (prev) prev.hidden = max <= 2 || x <= 2;
    if (next) next.hidden = max <= 2 || x >= max - 2;
  }

  function scrollByProduct(wrap, dir) {
    var step = columnWidth(wrap);
    if (!step) return;
    var max = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
    var index = Math.round(wrap.scrollLeft / step);
    var left = Math.max(0, Math.min(max, (index + dir) * step));
    wrap.scrollTo({ left: left, behavior: 'smooth' });
  }

  function bindTrimNav(wrap) {
    var scroller = wrap.closest('.collection-trim-compare__scroller');
    if (!scroller) return;
    if (!wrap.dataset.navBound) {
      wrap.dataset.navBound = 'true';
      var prev = scroller.querySelector('[data-trim-compare-prev]');
      var next = scroller.querySelector('[data-trim-compare-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          scrollByProduct(wrap, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollByProduct(wrap, 1);
        });
      }
      wrap.addEventListener(
        'scroll',
        function () {
          updateTrimNav(wrap);
        },
        { passive: true },
      );
      window.addEventListener('resize', function () {
        updateTrimNav(wrap);
      });
    }
    requestAnimationFrame(function () {
      updateTrimNav(wrap);
    });
  }

  function refreshTrimCompare() {
    document.querySelectorAll('[data-collection-trim-compare-section-id]').forEach(buildTable);
  }

  window.refreshTrimCompare = refreshTrimCompare;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshTrimCompare);
  } else {
    refreshTrimCompare();
  }
})();
